import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function About() {
  return (
    <PanelContent
      id="context_panel"
      route="/context"
      frTitle = "Bienvenue"
      enTitle = "Welcome"
      frSubtitle = "Rue Pierre Jean Grosley"
      enSubtitle = "Pierre Jean Grosley Street"
      frText = "Dans cette rue, l'esprit du Siècle des Lumières perdure. Une fresque dépeint deux humanistes : Robert Badinter, fervent défenseur de la justice contemporaine, et Pierre Jean Grosley, avocat et sociologue précurseur du siècle des Lumières. Cette fresque, lien entre passé et présent, incarne l'essence même de l'engagement humaniste."
      enText = "In this street, the spirit of the Enlightenment lives on. A mural depicts two humanists: Robert Badinter, a fervent advocate of modern justice, and Pierre Jean Grosley, a lawyer and sociologist who was a forerunner of the Enlightenment. This mural, bridging past and present, embodies the very essence of humanist commitment."
      frLeftButton=""
      enLeftButton = ""
      frRightButton="ÉTAPE SUIVANTE"
      enRightButton = "NEXT STEP"
      prev="/"
      next="/enigme"
    />
  );
}
